import { getDescriptionId, getFeedbackErrorId } from "./field";
export var getAriaDescribedByForInputField = function getAriaDescribedByForInputField(_ref) {
  var description = _ref.description,
    error = _ref.error,
    fieldId = _ref.fieldId;
  var hasError = Boolean(error);
  var hasDescription = Boolean(description);
  if (hasError && hasDescription) {
    return "".concat(getFeedbackErrorId(fieldId), " ").concat(getDescriptionId(fieldId));
  } else if (hasError) {
    return getFeedbackErrorId(fieldId);
  } else if (hasDescription) {
    return getDescriptionId(fieldId);
  }
  return undefined;
};